module.exports = __webpack_public_path__ + "img/Feature-4.60bc527.svg";